var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.sharedThreadId)?_c('shared-chat',{attrs:{"sharedThreadId":_vm.sharedThreadId}}):(!_vm.isAuthorized)?_c('user-auth',{on:{"authorized":_vm.onAuthorized}}):_c('chat-view',{attrs:{"userName":_vm.userName,"displayUserName":_vm.getDisplayUserName()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3187b2e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 